import React, { memo } from 'react'
import Logo1 from '../../../assets/logos/logo-1.webp'
import Logo2 from '../../../assets/logos/logo-2.webp'
import Logo3 from '../../../assets/logos/logo-3.webp'
import Logo4 from '../../../assets/logos/logo-4.webp'
import Logo5 from '../../../assets/logos/logo-5.webp'
import Logo6 from '../../../assets/logos/logo-6.webp'
import Logo7 from '../../../assets/logos/logo-7.webp'
import Logo8 from '../../../assets/logos/logo-8.webp'
import './style.css'

let listLogos: string[] = [Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8, Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8]

function CarouselConstructionCompanies() {
  return (
    <>
      <div id="sliderCarouselConstructionCompanies">
        <div className="slider">
          <div className="slide-track">
            {listLogos.map((item) => {
              return (
                <div className="slide text-center m-auto">
                  <img src={item} height="100" width="80" alt="" className='m-auto' />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}
export default memo(CarouselConstructionCompanies)
